<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex justify-between">
    <drdp-title [title]="t('ratingViewSetup.title')"></drdp-title>
  </div>

  <div class="flex justify-between mb-2" *drdpCheckPermission="permission.CreateBaseTemplates">
    <h2 class="text-[20px] font-bold"></h2>
    <span (click)="gotToBaseForm()">
      <drdp-btn><i class="uil uil-plus"></i> {{ t('ratingViewSetup.addBaseTemplate') }} </drdp-btn>
    </span>
  </div>

  @if (canSearch) {
    <drdp-container>
      <div class="w-full">
        <drdp-search [searchInput]="searchInput" (search)="getEnrollmentsByAgencyId($event)"
        (clear)="clearForm()"></drdp-search>
      </div>
    </drdp-container>
  }

  <drdp-container [additionClasses]="canSearch ? 'mt-5' : ''">
    @if (show2015Views) {
      <h2 class="text-[20px] font-bold mb-2">{{ t('ratingViewSetup.select2015Views') }}</h2>
      <hr>
        @if (!canViewResults) {
          <div class="mt-4"> {{ t('ratingViewSetup.selectAgencyPrompt') }} </div>
        }
        @if (canViewResults) {
          <form [formGroup]="defaultViewForm" class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-6">
            @if (hasIT) {
              <div class="form-input-label-group">
                <label class="font-normal required" for="itTemplateId">{{ t('ratingViewSetup.ageGroups.it') }}</label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <!-- Server-supplied option text: localized by the API, not by Transloco. -->
                  <mat-select formControlName="itTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                    @for (option of itOptions; track option) {
                      <mat-option [value]="option.id">
                        {{ option.description }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (hasPS) {
              <div class="form-input-label-group">
                <label class="font-normal required" for="psTemplateId">{{ t('ratingViewSetup.ageGroups.ps') }}</label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select formControlName="psTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                    @for (option of psOptions; track option) {
                      <mat-option [value]="option.id">
                        {{ option.description }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (hasTK) {
              <div class="form-input-label-group">
                <label class="font-normal required" for="tkTemplateId">{{ t('ratingViewSetup.ageGroups.tk') }}</label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select formControlName="tkTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                    @for (option of tkOptions; track option) {
                      <mat-option [value]="option.id">
                        {{ option.description }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (hasK) {
              <div class="form-input-label-group">
                <label class="font-normal required" for="kTemplateId">{{ t('ratingViewSetup.ageGroups.k') }}</label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select formControlName="kTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                    @for (option of kOptions; track option) {
                      <mat-option [value]="option.id">
                        {{ option.description }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (hasSA) {
              <div class="form-input-label-group">
                <label class="font-normal required" for="saTemplateId">{{ t('ratingViewSetup.ageGroups.sa') }}</label>
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select formControlName="saTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                    @for (option of saOptions; track option) {
                      <mat-option [value]="option.id">
                        {{ option.description }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          </div>
        </form>
      }
    }

    @if (show2025Views) {
        <div>
          <h2 class="text-[20px] font-bold mb-2 pt-5">{{ t('ratingViewSetup.views2025') }}</h2>
          <hr>
            @if (!canViewResults) {
              <div class="mt-4"> {{ t('ratingViewSetup.selectAgencyPrompt') }}</div>
            }
            @if (canViewResults) {
              <form [formGroup]="fieldStudyForm" class="mt-4">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-6">
                  <div class="form-input-label-group">
                    <label class="font-normal required" for="pilotItTemplateId">{{ t('ratingViewSetup.ageGroups.it') }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="pilotItTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                        @for (option of pilotItOptions; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-input-label-group">
                    <label class="font-normal required" for="ptkTemplateId">{{ t('ratingViewSetup.ageGroups.ptk') }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="ptkTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                        @for (option of ptkOptions; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-input-label-group">
                    <div class="flex items-center">
                      <label class="font-normal required" for="p3TemplateId">{{ t('ratingViewSetup.ageGroups.p3') }}</label>
                      <i class="uil uil-info-circle text-xs ms-1" [matTooltip]="p3Info"></i>
                    </div>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="p3TemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                        @for (option of p3Options; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-input-label-group">
                    <div class="flex items-center">
                      <label class="font-normal required" for="pilotSaTemplateId">{{ t('ratingViewSetup.ageGroups.sa') }}</label>
                      <i class="uil uil-info-circle text-xs ms-1" [matTooltip]="schoolAgeInfo"></i>
                    </div>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="pilotSaTemplateId" [placeholder]="t('ratingViewSetup.selectOption')">
                        @for (option of pilotSaOptions; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            }
          </div>
        }

      @if (showHistorical2015Views) {
        <div class="mt-6">
          <h2 class="text-[20px] font-bold mb-2">{{ t('ratingViewSetup.historical2015Views') }}</h2>
          <hr>
            @if (!canViewResults) {
              <div class="mt-4"> {{ t('ratingViewSetup.selectAgencyPrompt') }}</div>
            }
            @if (canViewResults) {
              <form [formGroup]="historical2015Form" class="mt-4">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-6">
                  @if (hasIT) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="histItTemplateId">{{ t('ratingViewSetup.ageGroups.it') }}</label>
                      <mat-form-field appearance="fill" class="drdp-input">
                        <mat-select formControlName="histItTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                          @for (option of histItOptions; track option) {
                            <mat-option [value]="option.id">
                              {{ option.description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (hasPS) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="histPsTemplateId">{{ t('ratingViewSetup.ageGroups.ps') }}</label>
                      <mat-form-field appearance="fill" class="drdp-input">
                        <mat-select formControlName="histPsTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                          @for (option of histPsOptions; track option) {
                            <mat-option [value]="option.id">
                              {{ option.description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (hasTK) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="histTkTemplateId">{{ t('ratingViewSetup.ageGroups.tk') }}</label>
                      <mat-form-field appearance="fill" class="drdp-input">
                        <mat-select formControlName="histTkTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                          @for (option of histTkOptions; track option) {
                            <mat-option [value]="option.id">
                              {{ option.description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (hasK) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="histKTemplateId">{{ t('ratingViewSetup.ageGroups.k') }}</label>
                      <mat-form-field appearance="fill" class="drdp-input">
                        <mat-select formControlName="histKTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                          @for (option of histKOptions; track option) {
                            <mat-option [value]="option.id">
                              {{ option.description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (hasSA) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="histSaTemplateId">{{ t('ratingViewSetup.ageGroups.sa') }}</label>
                      <mat-form-field appearance="fill" class="drdp-input">
                        <mat-select formControlName="histSaTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                          @for (option of histSaOptions; track option) {
                            <mat-option [value]="option.id">
                              {{ option.description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                </div>
              </form>
            }
        </div>
      }

      @if (showHistoricalEAViews) {
        <div class="mt-6">
          <h2 class="text-[20px] font-bold mb-2">{{ t('ratingViewSetup.historicalEAViews') }}</h2>
          <hr>
            @if (!canViewResults) {
              <div class="mt-4"> {{ t('ratingViewSetup.selectAgencyPrompt') }}</div>
            }
            @if (canViewResults) {
              <form [formGroup]="historicalEAForm" class="mt-4">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-6">
                  <div class="form-input-label-group">
                    <label class="font-normal" for="histEAItTemplateId">{{ t('ratingViewSetup.ageGroups.it') }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="histEAItTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                        @for (option of histEAItOptions; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-input-label-group">
                    <label class="font-normal" for="histEAPtkTemplateId">{{ t('ratingViewSetup.ageGroups.ptk') }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="histEAPtkTemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                        @for (option of histEAPtkOptions; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-input-label-group">
                    <div class="flex items-center">
                      <label class="font-normal" for="histEAP3TemplateId">{{ t('ratingViewSetup.ageGroups.p3') }}</label>
                      <i class="uil uil-info-circle text-xs ms-1" [matTooltip]="p3Info"></i>
                    </div>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select formControlName="histEAP3TemplateId" [placeholder]="t('ratingViewSetup.noPreviousView')" [disabled]="true">
                        @for (option of histEAP3Options; track option) {
                          <mat-option [value]="option.id">
                            {{ option.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            }
        </div>
      }

      @if (canViewResults) {
          <div class="mt-4 mb-2 flex justify-end">
            <drdp-btn (click)="submitForm()"
              [disabled]="!canEditRatingViews || defaultViewForm.invalid || fieldStudyForm.invalid || agency?.isRatingViewLocked"> {{ t('ratingViewSetup.saveAndLock') }}
            </drdp-btn>
            @if (canUnlockRatingViews && agency?.isRatingViewLocked) {
              <drdp-btn class="ml-2" (click)="unlockAgency()">
                {{ t('ratingViewSetup.unlock') }}
              </drdp-btn>
            }
          </div>
      }
    </drdp-container>

      @if (showAlternateRatingViews) {
      <drdp-container additionClasses="mt-5">
        <div class="flex justify-between mb-2">
          <h2 class="text-[20px] font-bold">{{ t('ratingViewSetup.alternateRatingViews') }}</h2>
          @if (canViewResults) {
            <span (click)="addCustomRatingModal()">
              <drdp-btn *drdpCheckPermission="permission.CreateRatingViews"><i class="uil uil-plus"></i> {{ t('ratingViewSetup.addAlternateRatingView') }}</drdp-btn>
          </span>
        }
        </div>
      <hr>
        @if (!canViewResults) {
          <div class="mt-4">{{ t('ratingViewSetup.selectAgencyPrompt') }}</div>
        }
        @if (canViewResults) {
          <div>
            <drdp-add-edit-table class="left-justified" [dataSource]="dataSource" [tableData]="customTemplates"
              [columns]="customTableColumns" viewIcon="uil uil-file text-drdpblue-300"
              (viewActionItem)="viewCustomForm($event)" (deleteActionItem)="deleteModal($event)">>
            </drdp-add-edit-table>
          </div>
        }
      </drdp-container>
    }
    </div>
</ng-container>
